import { Box,Button,useMediaQuery,useTheme,MenuItem,InputLabel,FormControl } from "@mui/material";
import Select from '@mui/material/Select';
import { DataGrid, esES, GridToolbar } from "@mui/x-data-grid";
import { useLocation,useNavigate } from "react-router-dom";
import useAuth from "../../../../auth/useAuth";
import Header from "../../../../components/Header";
import { useFetchGET } from "../../../../state/FetchHelpers";
import { addRoleToUserRoute, deleteRoleToUserRoute, rolesListRoute, userRolesListRoute } from "../../../../config";
import Loading from "../../../global/Loading";
import FatalError from "../../../global/FatalError";
import DeleteIcon from '@mui/icons-material/Delete';
import { tokens } from "../../../../theme";
import { useEffect, useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import swal from "sweetalert";
import * as yup from "yup";
import { Formik } from "formik"

const UserRoles = ({permissionsListData}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode)
  const auth = useAuth();
  const token = auth.globals.token
  const isNonMobile = useMediaQuery("(min-width:600px)")

  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const _id = query.get('id')

  const navigate = useNavigate();

  const [ loadingRequest, setLoadingRequest ] = useState(false)
  const [ errorRequest, setErrorRequest ] = useState(null)

  const [reloadData, setReloadData] = useState(false);
  const handleReloadData = () => {
    setReloadData(true);
  };

  useEffect(() => {
    // Llama a la función para recargar datos cuando reloadData cambie a true
    if (reloadData) {
      handleReloadData();
      setReloadData(false);
      setInicitalValues({
        user: _id,
        rol: "",
        create_user: auth.globals.id.toString()
      })
    }
  }, [reloadData,auth.globals.id,_id]);

  const { data: userRolesListData, loading: userRolesListLoading, error: userRolesListError } = useFetchGET(_id!=null?userRolesListRoute(_id):undefined,token,[],reloadData);
  //console.log(userRolesListData)

  const { data: rolesListData, loading: rolesListLoading, error: rolesListError } = useFetchGET(rolesListRoute(), token, [],reloadData);
  //console.log('Listado de todos los roles: ',rolesListData)

  const filterRolesList = () => {
    // Crear un conjunto (Set) de IDs de userRolesListData para búsquedas eficientes
    const userRolesIds = new Set(userRolesListData.map(userRole => userRole.id));
  
    // Revisar si el permissionsListData incluye el ID 48
    const includeRole1 = permissionsListData.includes(48);
    // Filtrar rolesListData para excluir aquellos que están en userRoleesIds
    // Además, excluir el rol con id = 1 si includeRole1 es falso
    return rolesListData.filter(role => {
      const isRole1AndNotIncluded = role.id === 1 && !includeRole1;
      return !userRolesIds.has(role.id) && !isRole1AndNotIncluded;
    });
  }

  const filteredRolesList = filterRolesList();

  
  const mostrarErrorRequest=(error)=>{
    if(error!=null){
      try{
        swal({
          title:"Error",
          text: "Resultado: "+error,
          icon: "error",
          button:"Aceptar"
        })
        if(error==="No tiene autorización o su sesión ha expirado"){
          auth.logout();
        }
      }catch(e){
        swal({
          title:"Error",
          text: "Error inesperado ",
          icon: "error",
          button:"Aceptar"
        })
      }
    }
    setErrorRequest(null)
  }

  const alertSucess=(text_title,text_content='')=>{    
    try{
      swal({
        title:text_title,
        text: text_content,
        icon: "success",
        button:"Aceptar"
      })
    }catch(e){
      swal({
        title:"Error inesperado",
        text: "Error inesperado ",
        icon: "error",
        button:"Aceptar"
      })
    }
    navigate("/Users/Form?id="+_id)
  }

  const newUserRol = async(body) =>{
    //console.log('bpdy',body)
    try{
      
      let res = await fetch(addRoleToUserRoute(), {
        method: "POST",
        headers: {
          //"Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Accept":"application/json",
          "Authorization": `Bearer ${token}`
          //"x-access-token": token,
        },
        body: JSON.stringify(body),
        //cors: 'no-cors'
      })
      let data = await res.json()
      //console.log(res)
      if(res.ok){
        setLoadingRequest(false)
        alertSucess('Rol Agregado',data.message)
        navigate("/Users/Form?id="+_id)
        setReloadData(true);       
      }else{
        //console.log('res else',res)
        if(res.status === 401||res.status === 403){
          mostrarErrorRequest("No tiene autorización o su sesión ha expirado")          
        }
        mostrarErrorRequest(data.detail)
        setErrorRequest(data.detail)    
      }
      setLoadingRequest(false) 
      return data;
    }catch(errorRequest){
      //console.log('errorRequest',errorRequest)
      setLoadingRequest(false)
      setErrorRequest(errorRequest)
    }
  }


  const deleteUserRole = async(id_role,id_user) =>{
    //console.log('bpdy',body)
    try{
      //setLoadingRequest(true)
      let res = await fetch(deleteRoleToUserRoute(id_role,id_user), {
        method: "DELETE",
        headers: {
          //"Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Accept":"application/json",
          "Authorization": `Bearer ${token}`
        },
        //cors: 'no-cors'
      })
      let data = await res.json()
      //console.log('resultado',data)
      if(res.ok){ 
        setReloadData(true);
        try{
          if(data.message === 'No es posible eliminar el rol del usuario porque es un rol principal.'){
            mostrarErrorRequest(data.message)
          }
        }catch{
          //console.log(data)
        }             
      }else{
        //console.log('res else',res)
        if(res.status === 401||res.status === 403){
          mostrarErrorRequest("No tiene autorización o su sesión ha expirado")          
        }
        mostrarErrorRequest(data.detail)
        setErrorRequest(data.detail)    
      }
      setLoadingRequest(false) 
      return data;
    }catch(errorRequest){
      //console.log('errorRequest',errorRequest)
      setLoadingRequest(false)
      setErrorRequest(errorRequest)
    }
  }


  const [initialValues,setInicitalValues] = useState({
    user: _id,
    role: "",
    create_user: auth.globals.id.toString()
  })

  const userSchema = yup.object().shape({
    role: yup.string().required("* Valor Requerido"),
  })


  const handleFormSubmit = (values) => {
    //console.log('values',values)
    setInicitalValues(values)
    setLoadingRequest(true)
    newUserRol(values)
    //console.log('Nueva bodega')
  }

  const handleChangeAction = (values,target) =>{
    values[target.name]=target.value.toString();
  }


  const columns=[
    {
      field:"id", 
      headerName: "ID",
      cellClassName: "id-column--cell",
      headerClassName: "id-header--cell",
      hideable:false
    },
    {
      //hide: true,
      field:"name", 
      headerName: "Nombre",
      flex: 0.5, 
      cellClassName: "name-column--cell",
      minWidth:120
    },
    {
      minWidth:200,
      filterable:false,
      sortable:false,
      field:"actions", 
      headerName: "Acciones",
      headerAlign:"center",
      cellClassName: "actions-column--cell",
      renderCell:({ row: { id} })=>{
        return(
          <Box
            width="80%"
            maxWidth="175px"
            height="75%"
            maxHeight="35px" 
            display="flex" 
            justifyContent="center" 
            m="0 auto">
            <Button
              color="error"
              variant="contained"
              onClick={()=>{deleteUserRole(id,_id)}}>
            <DeleteIcon/>
              <Box sx={{ml:"5px"}}>
                Eliminar Rol
              </Box>
            </Button>
          </Box>
        )
      }
    }
  ]

  if(userRolesListLoading||loadingRequest||rolesListLoading)
  return (<Loading/>)

  if(userRolesListError||errorRequest||rolesListError)
  return(<FatalError/>)

  return (
    <Box p={1} >
      {/*<Box display="flex" justifyContent="space-between" alignItems="center">*/}
      {<Header title="" subtitle="Listado de Roles Asignados"/>}
      <Formik
        enableReinitialize={true}
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema = {userSchema}
      >
      {({
        values, 
        errors, 
        touched, 
        handleBlur, 
        handleChange,
        handleSubmit,
        setFieldValue
      }) => (
        <form onSubmit={handleSubmit} >
          <Box
            display="grid" 
            gap="15px"
            marginBottom="15px" 
            gridTemplateColumns="repeat(12, minmax(0, 1fr))"
            sx={{
              "& > div": { gridColumn: isNonMobile? undefined : "span 12"}
            }}
          >        
          {<FormControl variant="filled"
            sx={{ gridColumn: "span 12"}}
            required>
            <InputLabel id="select-role-label" name="select-role-label">Permiso</InputLabel>
            <Select
              labelId="select-role-label"
              id="select-role"
              fullWidth={!isNonMobile}
              onBlur = {handleBlur}
              onChange = {(e) => {
                handleChangeAction(values,e.target);
                setFieldValue("role", e.target.value);
              }}
              value = {values.role||''}
              name = "role"
              size="small"
            >
              {/*{storesListData.map((store) => (*/}
              {filteredRolesList.map((action) => (
                <MenuItem key={action.id} value={action.id.toString()}>
                  {action.name}
                </MenuItem>
              ))}
            </Select>                  
          </FormControl>}
          </Box>
              <Box display="flex" justifyContent="end" mt="20px">               
                <Button type="submit" color="secondary" variant="contained">
                  <AddIcon/>
                    Agregar Rol
                </Button>                           
              </Box>
        </form>
        )}
      </Formik>
      <Box m="5px 0px 50px 0" /*height={isNonMobile?"100%":undefined}*/ sx={{
        "& .MuiDataGrid-root":{
          border: "none",
        },
        "& .MuiDataGrid-cell":{
          borderBottom: "none"
        },
        "& .MuiDataGrid-columnHeaders":{
          backgroundColor: colors.blueAccent[700],
          borderBottom: "none",
          color: "white"
        },
        "& .MuiDataGrid-virtualScroller":{
          backgroundColor: colors.primary[400],
        },
        "& .MuiDataGrid-footerContainer":{
          borderTop: "none",
          backgroundColor: colors.blueAccent[700],
        },
        "& .MuiDataGrid-toolbarContainer .MuiButton-text":{
          color: `${colors.grey[100]} !important`,
        },
        "& .MuiToolbar-gutters":{
          color: "white"
        }

      }}>
        <DataGrid
          autoHeight
          initialState={{
            columns: {
              columnVisibilityModel: {
                // Hide columns status and traderName, the other columns will remain visible
                id: false,
                actions:true
              },
            },
          }}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          rows={userRolesListData}
          columns={columns}
          getRowId={(row) => row.id}
          density="compact"
          slots={{
            toolbar: GridToolbar,
          }}
        />
      </Box>
    </Box>
  );


}

export default UserRoles;